const AuthFooter = () => {
	return (
		<div className="w-full flex flex-wrap text-sm text-gray-900">
			<ul className='flex flex-wrap'>
				<li>Terms</li>
				<li className='ml-7  list-disc'>Privacy Policy</li>
			</ul>
			<div className="ml-auto">
				© All rights reserved. 
			</div>
		</div>
	)
}

export default AuthFooter;